<template>
	<v-dialog
		v-model="dialog"
		max-width="960px"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
	>
		<template v-slot:activator="{ on, attrs }">
			<v-btn color="black" text class="mr-2 print-btn" v-bind="attrs" v-on="on"
				><v-icon class="mr-1">mdi-send</v-icon>メール送信</v-btn
			>
		</template>
		<v-card :tile="$vuetify.breakpoint.xs">
			<v-app-bar dark color="primary" dense flat>
				<v-app-bar-title class="color-white">発注メール送信</v-app-bar-title>
				<v-spacer></v-spacer>
				<v-btn icon dark @click="dialog = false" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-app-bar>
			<v-form class="pa-2" ref="form" v-model="valid">
				<v-row no-gutters>
					<v-col cols="12" sm="6">
						<v-combobox
							type="text"
							v-model="mailInfo.emails"
							:rules="[rules.required]"
							label="TO"
							class="mr-sm-2 mt-4"
							dense
							outlined
							multiple
						/>
					</v-col>
					<v-col cols="12" sm="6">
						<v-combobox
							type="text"
							v-model="mailInfo.cc_emails"
							label="CC"
							class="mt-4"
							dense
							outlined
							multiple
						/>
					</v-col>
				</v-row>
				<v-text-field
					type="text"
					label="メールタイトル(必須)"
					class="mt-4"
					:rules="[rules.required]"
					dense
					v-model="mailInfo.title"
					outlined
				/>
				<v-textarea
					label="メール文章(必須)"
					class="mt-4 mb-4"
					:rules="[rules.required]"
					outlined
					v-model="mailInfo.content"
					dense
					auto-grow
				/>
				<DragUpload @fileShare="fileShare" />
			</v-form>
			<div class="ma-5 text-body-2">
				配車依頼書を送付する際は、配車依頼書ページの右上にある『印刷』ボタンをクリックし、PDFファイルとして保存してください。保存後は、配車依頼書を添付する欄にファイルをアップロードしてください。<br />
			</div>

			<v-row justify="center" no-gutters class="mt-4 pb-4">
				<v-col cols="12" sm="6">
					<v-row justify="space-around" no-gutters>
						<v-btn color="secondary" :disabled="!valid" @click="sendMail()">メールを送信</v-btn>
						<v-btn @click="dialog = false">キャンセル</v-btn>
					</v-row>
				</v-col>
			</v-row>
		</v-card>
	</v-dialog>
</template>

<script>
import axios from "axios"
import authenticate from "../../../helper/authenticate"
import errorHandling from "../../../helper/errorHandling"
import rules from "../../../helper/rules"
import common from "../../../helper/common"
import DragUpload from "../../shared/DragUpload.vue"
import moment from "moment"
import "moment/locale/ja"

export default {
	props: {
		delivery_order: {
			type: Object,
			required: true,
		},
		infosByAddress: {
			type: Array,
			required: true,
		},
		company_name: {
			type: String,
			required: true,
		},
		user_name: {
			type: String,
			required: true,
		},
		id: {
			type: String,
			required: true,
		},
	},
	components: {
		DragUpload,
	},
	data() {
		return {
			confirmation: "",
			uploadFiles: [],
			mailInfo: {
				title: "",
				content: "",
				emails: [],
				cc_emails: [],
			},
			fileNames: [],
			valid: false,
			dialog: false,
			rules,
			common,
			infoPromise: null,
		}
	},
	filters: {
		dateFormatter(date) {
			if (!date) return
			moment.locale("ja")
			return moment(date).format("YYYY年MM月DD日(dd)")
		},
	},

	mounted() {
		this.setEmail()
	},
	methods: {
		fileShare(files) {
			this.uploadFiles = files
		},
		sendMail() {
			let formData = new FormData()

			formData.set("mail_infos[title]", this.mailInfo.title)
			formData.set("mail_infos[content]", this.mailInfo.content)
			this.mailInfo.emails.forEach((email) => {
				formData.append("mail_infos[emails]" + "[]", email)
			})
			this.mailInfo.cc_emails.forEach((cc_email) => {
				formData.append("mail_infos[cc_emails]" + "[]", cc_email)
			})

			if (this.uploadFiles.length) {
				this.uploadFiles.forEach((file) => {
					formData.append(
						"mail_infos[files]" + "[]",
						new Blob([file], {
							type: file.type,
						}),
						file.name
					)
				})
			}

			const headers = authenticate.setHeader()
			const url = `/erp/v1/delivery_orders/${this.id}/mail_infos`

			axios
				.post(url, formData, { headers })
				.then((res) => {
					this.$store.dispatch("setFlash", {
						type: "notice",
						text: "メールを送信しました。",
					})
					this.$router.push({ name: "delivery_order_index" })
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		setContent() {
			let text = ""
			if (this.delivery_order.supplier.email) {
				if (
					this.delivery_order.original_order_id &&
					this.delivery_order.original_order?.send_by_fax == false
				) {
					text = `拝啓 ${this.delivery_order.pic_name} 様\n\nいつもお世話になっております。${
						this.company_name
					}の${
						this.$store.getters["auth/authData"].full_name
					}と申します。\n\n新規の注文ではなく、先日送信した注文番号${
						this.delivery_order.original_order.order_number +
						"-" +
						this.delivery_order.original_order.sub_number
					}分の修正です。\n詳細については以下の通りです。\n\n`
				} else {
					text = `拝啓 ${this.delivery_order.pic_name} 様\n\nいつもお世話になっております。${this.company_name}の${this.$store.getters["auth/authData"].full_name}と申します。\n\nこの度、${this.delivery_order.shipping_place.name}からの荷物の発送をご依頼いたします。詳細については以下の通りです。\n\n`
				}
				text += `【車種情報】\n`
				this.delivery_order.delivery_order_cars.forEach((c, index) => {
					text += `${index + 1}.\n`
					text += `・車種：${c.car_model}\n`
					text += `・台数/式：${c.number_of_cars}\n\n`
				})
				text += `【荷物・発送先情報】\n`
				const infosByAddress = this.infosByAddress
				infosByAddress.forEach((i) => {
					i.infos.forEach((orderIndividualInfo, index) => {
						if (index == 0) {
							text += `・製品名：${orderIndividualInfo.ordered_product.product.name} ${orderIndividualInfo.quantity}台\n`
						} else {
							text += `　　　　　${orderIndividualInfo.ordered_product.product.name} ${orderIndividualInfo.quantity}台\n`
						}
					})
					text += `・会社名：${i.delivery_info.company_name}\n`
					text += `・担当者名：${i.delivery_info.person_name}\n`
					text += `・郵便番号：${i.delivery_info.zipcode}\n`
					text += `・住所：${i.delivery_info.prefecture}${i.delivery_info.city}${i.delivery_info.address}\n`
					text += `・電話番号：${i.delivery_info.phone}\n`
					text += `・発送日：${common.formatDate(i.delivery_info.shipping_date)}\n`
					text += `・納入日：${common.formatDate(i.delivery_info.deadline)} ${common.formatTime(
						i.delivery_info.deadline_time
					)}\n`
				})
				text += `以上、よろしくお願いいたします。\n\n敬具\n\n${this.$store.getters["auth/authData"].full_name}`
				this.mailInfo.content = text
			} else {
				text += "メールアドレスが登録されていません"
				this.mailInfo.content = text
			}
		},
		setEmail() {
			// Todo this.infosByAddressが取得できない段階でsetEmailが動いてるため参照できない場合がある
			const infosByAddress = this.infosByAddress

			let title
			if (
				this.delivery_order.original_order_id &&
				this.delivery_order.original_order?.send_by_fax == false
			) {
				title = `【訂正】${this.company_name}から${infosByAddress[0].delivery_info.company_name}への荷物発送の依頼`
			} else {
				title = `${this.company_name}から${infosByAddress[0].delivery_info.company_name}への荷物発送の依頼`
			}
			this.mailInfo.title = title
			this.setContent()
			this.mailInfo.emails.push(this.delivery_order.supplier.email)
			this.mailInfo.cc_emails.push(this.$store.getters["auth/authData"].uid)
		},
		formatDate(date) {
			if (!date) return ""
			return moment(date).format("YYYY年MM月DD日")
		},
	},
}
</script>

<style scoped lang="scss">
.v-card {
	overflow-x: hidden;
}

@media print {
	.print-btn {
		display: none;
	}
}
</style>
